import { Info } from "lucide-react";

// Sources agree on the main fact; these small details (numbers, times, spellings) differ between them.
export const MinorDifferences = ({ items, status, testid = "fact-minor-differences", compact = false }) => {
  if (!items?.length) return null;
  const sub = ["DISPUTED", "CONTRADICTED", "MIXED"].includes(status) ? "These small differences are separate from the main disagreement." : "The sources agree on the main fact, so it isn't treated as disputed.";
  return (
    <div className={`rounded-xl border border-sky-200 bg-sky-50 text-sky-950 ${compact ? "p-2.5 text-xs" : "p-4 text-sm"}`} data-testid={testid}>
      <p className="flex items-center gap-1.5 font-semibold"><Info size={compact ? 12 : 15} className="shrink-0" />Minor details differ between sources</p>
      <p className={`mt-0.5 ${compact ? "" : "text-xs"} text-sky-900/80`}>{sub}</p>
      <ul className="mt-2 list-disc space-y-1 pl-5">{items.map((m, i) => {
        const d = typeof m === "string" ? { detail: m } : m;
        return <li key={i} data-testid={`${testid}-${i}`}>{d.detail}{d.sources?.length ? <span className="text-sky-900/60"> ({d.sources.join(", ")})</span> : null}</li>;
      })}</ul>
    </div>
  );
};
